import moment from "moment"
import { isDateDifferenceGreaterThan } from "../dates/dates"
import { StageBugReport } from "../dbModels"
import { getProfilePictureByUserId } from "../requestsUtils/functionsRequests/user/userFunctions"

type UserImageInfoCache = {
    url: string
    date: string
}

class UserImageCache{
    userImageCache = new Map<string, UserImageInfoCache>()

    // the same user id can exist in another stage, so the stage is part of the key
    #key(id: string, stage?: StageBugReport) {
        return stage ? `${stage}:${id}` : id
    }

    addUrl(id: string, url: string, stage?: StageBugReport) {
        const date = moment().toISOString()
        this.userImageCache.set(this.#key(id, stage), { date, url })
    }

    async getUrl(id: string, size: "small" | "mid" | "" = "small", stage?: StageBugReport): Promise<string> {
        const date = moment().toISOString()
        const obj = this.userImageCache.get(this.#key(id, stage))
        if(isDateDifferenceGreaterThan(date, 3600) || !obj){
            try {
                const url = await getProfilePictureByUserId(id, size, stage)
                return url
            } catch (error) {
                return ""
            }
        }else{
            return obj?.url
        }
    }
}

export const userImageCache = new UserImageCache()